import Axios from "axios";
import Vue from "vue";
import _ from "lodash";
import i18n from "../../i18n";
import { API_HOST } from "../../config/app-const";
import { getUrlParams } from '../../helpers/pagination';

const state = {
  articleGroup: {
    isBusy: false,
    updating: false,
    data: [],
    pagination: {},
    error: null
  },
  articlesByGroup: {
    isBusy: false,
    data: [],
    pagination: {},
    error: null
  },
};

const mutations = {

// PROJECT SETUP - ARTICLE_GROUP--------------------------
  LOAD_ARTICLE_GROUP_BUSY: (state, payload) => {
    state.articleGroup.isBusy = payload;
  },
  LOAD_ARTICLE_GROUP_SUCCESS: (state, {data=[], pagination}) => {
    if (pagination && pagination.currentPage === 1) state.articleGroup.data = []
    data.forEach(group => state.articleGroup.data.push(group))
    if(pagination) state.articleGroup.pagination = pagination;
    state.articleGroup.error = null;
  },
  LOAD_ARTICLE_GROUP_FAIL: (state, payload) => {
    state.articleGroup.error = payload;
    state.articleGroup.data = null;
  },
  UPDATE_ARTICLE_GROUP_BUSY(state, payload) {
    state.articleGroup.isBusy = payload;
  },
  UPDATE_ARTICLE_GROUP_SUCCESS(state, payload) {
    state.articleGroup.data = payload;
    state.articleGroup.error = null;
  },
  UPDATE_ARTICLE_GROUP_FAIL: (state, payload) => {
    state.articleGroup.error = payload;
    state.articleGroup.data = null;
  },
  //------------------------------------------------

  //PROJECT SETUP - ARTICLES BY GROUP --------------
  LOAD_ARTICLE_BY_GROUP_BUSY: (state, payload) => {
    state.articlesByGroup.isBusy = payload;
  },
  LOAD_ARTICLE_BY_GROUP_SUCCESS: (state, payload) => {
    state.articlesByGroup.data = payload;
    state.articlesByGroup.error = null;
  },
  LOAD_ARTICLE_BY_GROUP_FAIL: (state, payload) => {
    state.articlesByGroup.error = payload;
    state.articlesByGroup.data = null;
  },
  //------------------------------------------------

  LOAD_GROUP_BUSY: (state, payload) => {
    state.articleGroup.isBusy = payload;
  },
  LOAD_GROUP_SUCCESS: (state, {data, pagination}) => {
    if (pagination && pagination.currentPage === 1) state.articleGroup.data = []
    data.forEach(group => state.articleGroup.data.push(group))
    if(pagination) state.articleGroup.pagination = pagination;
    state.articleGroup.error = null;
  },
  LOAD_GROUP_FAIL: (state, payload) => {
    state.articleGroup.error = payload;
    state.articleGroup.data = null;
  },
  CREATE_GROUP_ARTICLES_BUSY: (state, payload) => {
    state.articleGroup.updating = payload;
  },
  CREATE_GROUP_ARTICLES_SUCCESS: (state, payload) => {
    state.articleGroup.error = null;
  },

  CREATE_GROUP_ARTICLES_FAIL: (state, payload) => {
    state.articleGroup.error = payload;
  },
  DELETE_GROUP_ARTICLES_BUSY: (state, payload) => {
    state.articleGroup.updating = payload;
  },
  DELETE_GROUP_ARTICLES_SUCCESS: (state, payload) => {
    state.articleGroup.error = null;
  },
  DELETE_GROUP_ARTICLES_FAIL: (state, payload) => {
    state.articleGroup.error = payload;
    state.articleGroup.data = null;
  },
  ORDER_GROUPS: (state, order) => {
    state.articleGroup.data = _.orderBy(state.articleGroup.data, [order.order], [order.direction]);
  }
}

const actions = {

  getArticleGroup: ({ commit, rootState }, { projectUid, filters, pagination }) => {
    commit("LOAD_ARTICLE_GROUP_BUSY", true);

    let url = `${API_HOST}/analysis/${projectUid}/groups`;
    const query = getUrlParams({ ...pagination, search: filters });

    if (query) url += `?${query}`; 

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios.get(url, config)
      .then(({data}) => {
        commit("LOAD_ARTICLE_GROUP_SUCCESS", data.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_ARTICLE_GROUP_FAIL", error);
      })
      .finally(() => commit("LOAD_ARTICLE_GROUP_BUSY", false));

  },

  updateGroup: ({ commit, rootState }, { projectUid, groupId, payload }) => {
    commit("UPDATE_ARTICLE_GROUP_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    const body = {
      ...payload
    };

    Axios.put(
      `${API_HOST}/analysis/projects/${projectUid}/groups/${groupId}/update`,
      body,
      config
    )
      .then(response => {
        commit("UPDATE_ARTICLE_GROUP_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("UPDATE_ARTICLE_GROUP_FAIL", error);
      })
      .finally(() => commit("UPDATE_ARTICLE_GROUP_BUSY", false));
  },

  getArticlesByGroup: ({ commit, rootState }, { projectUid, groupId}) => {
    commit("LOAD_ARTICLE_BY_GROUP_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    Axios.get(`${API_HOST}/analysis/${projectUid}/groups/${groupId}/articles`, config)
      .then(response => {
        commit("LOAD_ARTICLE_BY_GROUP_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_ARTICLE_BY_GROUP_FAIL", error);
      })
      .finally(() => commit("LOAD_ARTICLE_BY_GROUP_BUSY", false));
  },

  getGroup: ({ commit, state, rootState }, { projectId, groupId }) => {
    commit("LOAD_GROUP_BUSY"), true;

    const { accessToken } = rootState.user.user.data;

    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios.get(`${API_HOST}/analysis/${projectId}/groups/${groupId}`, config)
      .then(response => {
        commit("LOAD_GROUP_SUCCESS", response.data);
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("LOAD_GROUP_FAIL", error);
      })
      .finally(() => commit("LOAD_GROUP_BUSY", false));
  },
  createGroup: ({ commit, rootState }, { projectUid, group }) => {
    commit("CREATE_GROUP_ARTICLES_BUSY", true);

    const { accessToken } = rootState.user.user.data;
    const config = {
      headers: { Authorization: `Token token=${accessToken}` }
    };

    return Axios.post(
      `${API_HOST}/analysis/${projectUid}/groups/create`,
      group,
      config
    )
      .then(response => {
        Vue.notify({
          group: "store_notifications",
          type: "success",
          text: i18n.t("group.messages.created")
        });
        commit("CREATE_GROUP_ARTICLES_SUCCESS", response.data);
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("CREATE_GROUP_ARTICLES_FAIL", error);
        return;
      })
      .finally(() => commit("CREATE_GROUP_ARTICLES_BUSY", false));
  },
  removeGroup: ({ commit, rootState }, { projectId, groupId, afrRuleIds = [] }) => {
    commit("DELETE_GROUP_ARTICLES_BUSY", true);

    const { accessToken } = rootState.user.user.data;

    const config = {
      headers: { Authorization: `Token token=${accessToken}` },
      data: afrRuleIds.length > 0 ? { afrRuleIds } : {}
    };

    return Axios.delete(
      `${API_HOST}/analysis/${projectId}/groups/${groupId}/remove`,
      config
    )
      .then(response => {
        commit("DELETE_GROUP_ARTICLES_SUCCESS", groupId);
        return response.data;
      })
      .catch(error => {
        Vue.notify({
          group: "store_notifications",
          type: "error",
          text: i18n.t("messages.request.error")
        });

        console.error(error);
        commit("DELETE_GROUP_ARTICLES_FAIL", error);
        throw error;
      })
      .finally(() => commit("DELETE_GROUP_ARTICLES_BUSY", false));
  },
  orderGroups({ commit }, order) {
    commit('ORDER_GROUPS', order);
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
};